export enum LicenceTypeEnum {
  STARTER = 'starter',
  STANDARD = 'standard',
  PREMIUM = 'premium',
}
